'use strict';
var localisations = require('../account.localisations');

export default class ForgottenController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $location, common, $routeParams, $http) {
    var that= this;
    this.Auth = Auth;
    this.$location = $location;
    this.common = common;
    this.common.setPageTitle('');
    this.localisations = localisations[this.common.getLocale()];
    this.sending = false;
    this.email = $routeParams.email;
    this.resetCode = $routeParams.code;
    this.isActivated = false;
    if (typeof this.resetCode !== 'undefined') {
      // Check code and show message if invalid;
      var promise = $http.get('/api/users/' + this.resetCode + '/' + this.email + '/activate');
      promise.then(response => {
        if (response.data) {
          that.isActivated = true;
        }
      }).catch(err => {
          common.setAlert("Error", "danger", "Error activating account. Please try again.(Error " + err.status +  ": " + err.statusText + ")", false, true)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/activate/activate.controller.js